import SendingMessage from "./SendingMessage";

export default SendingMessage;
